export var Year;
(function (Year) {
    Year[Year["min"] = 1000] = "min";
    Year[Year["max"] = 9999] = "max";
})(Year || (Year = {}));
//# sourceMappingURL=year.enum.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/enums/year.enum.js
// module id = 203
// module chunks = 10